import * as React from "react";
import { useEffect, useState, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { getCurrentCard, setCreditCardLoading } from "../../../store/actions/Business";
import { updateCard } from "../../../services/business";
import { pushNotification } from "../../../store/actions/Notifications";
import { ERROR, Notification, SUCCESS } from "../../../models/Notification";
import { deleteInsurerOfferByUserAssuranceId, getAssuranceById, getInsurerDetails, getInsurerOfferByUserAssuranceId, getNewInsuranceOffer } from "../../../services/insurer";
import { StationsTable } from "../../../table/station/StationsTable"
import { ChevronRightIcon, MailIcon } from '@heroicons/react/solid'
import { setUserAssurance } from "../../../store/actions/Insurance";
import Modal from "../../../components/Modal/Modal";
import NewOfferModal from "./NewOfferModal";
import Button from "../../../components/ButtonGroup/Button";
import dayjs from "dayjs";
import { findPriceRange, priceRange } from "../../../utils/priceRange";



const InsuranceOfferDetail = () => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
 // const [isYousetModalOpen, setIsYousetModalOpen] = useState(false);
  const [didFetchDetail, setDidFetchDetail] = useState(false);
  const [page, setPage] = useState(1);
  const [csvLoading, setCsvLoading] = useState(false);
  const { t } = useTranslation(['insurer', 'neatcover', 'month']);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { offerId } = useParams();
  const [insurerOffer, setInsurerOffer] = useState(undefined);
  const [insurerDetails, setInsurerDetails] = useState(null);

  const insuranceStore = useSelector(store => store.insurance);
  const userAssurance = insuranceStore.userAssurance;

  useEffect(() => {
    if (!didFetchDetail) {

      getInsurerDetails().subscribe({
        next: (insurerDetails) => {
          setInsurerDetails(insurerDetails.insurerDetails);
        }
      });

      const userAssuranceId = parseInt(offerId);
      getAssuranceById(userAssuranceId).subscribe({
        next: (userAssuranceDetail) => {
          dispatch(setUserAssurance(userAssuranceDetail.assurance));
        }
      });

      getInsurerOfferByUserAssuranceId(userAssuranceId).subscribe({
        next: (insurerOffer) => {
          setInsurerOffer(insurerOffer.offer);
        }
      });

      setTimeout(() => {
        setDidFetchDetail(true);
      }, 1000);
    }
  }, [didFetchDetail])

  const deleteOffer = React.useCallback(() => {
    const userAssuranceId = parseInt(offerId);
    deleteInsurerOfferByUserAssuranceId(userAssuranceId).subscribe({
      next: (response) => {
        navigate('/Insurer');
      }
    });
  }, [offerId])

  const userHaveTicket = userAssurance?.informations.last5YearsTickets0 === "yes";

  const tickets = React.useMemo(() => {
    if (userAssurance) {
      var tmpTickets = [];
      for (let i = 0; i < 100; i++) {
        if (userAssurance?.informations[`explainTicket${i}`]) {
          tmpTickets.push({
            explain: userAssurance?.informations[`explainTicket${i}`],
            year: userAssurance?.informations[`ticketYear${i}`]
          })
        }
      }
      return tmpTickets;
    }
  }, [userAssurance]);

  const userHaveAccident = userAssurance?.informations.last6YearsAccidents0 === "yes";

  const accidents = React.useMemo(() => {
    if (userAssurance) {
      var tmpTickets = [];
      for (let i = 0; i < 100; i++) {
        if (userAssurance?.informations[`explainAccident${i}`]) {
          tmpTickets.push({
            explain: userAssurance?.informations[`explainAccident${i}`],
            claimAmount: userAssurance?.informations[`claimAmount${i}`],
            claimDate: dayjs(userAssurance?.informations[`claimDate${i}`]).format('YYYY-MM-DD')
          })
        }
      }
      return tmpTickets;
    }
  }, [userAssurance]);

  const userHaveInsuranceDetailCar= userAssurance?.informations.insuranceDetailCar && userAssurance?.informations.insuranceDetailCar.length > 0;
  const userInsuranceDetailCar = userHaveInsuranceDetailCar && userAssurance?.informations.insuranceDetailCar.split(',');

  const userHaveInsuranceDetailHome= userAssurance?.informations.insuranceDetailHome && userAssurance?.informations.insuranceDetailHome.length > 0;
  const userInsuranceDetailHome = userHaveInsuranceDetailHome && userAssurance?.informations.insuranceDetailHome.split(',');

  const priceThreshold = findPriceRange(userAssurance?.informations.assuranceAmount_yearly, t);

  const capitalize = s => s && String(s[0]).toUpperCase() + String(s).slice(1)

  const discountsKey = userAssurance?.informations.discount?.split(',') || [];
  const discountsLabel = discountsKey?.map(key => t(`insurer:${key}`)).join(', ');

  const discountOptions = useMemo(() => ["student","retired","maried","fullTimeWork","universityDegree","professionalAssociation"], [])

  const userInsuranceDetailCarKey = userInsuranceDetailCar || [];
  const userInsuranceDetailCarLabel = userInsuranceDetailCarKey?.map(key => t(`insurer:${key}`));

  const userInsuranceDetailHomeKey = userInsuranceDetailHome || [];
  const userInsuranceDetailHomeLabel = userInsuranceDetailHomeKey?.map(key => t(`insurer:${key}`));

  const limitReached = insurerDetails && insurerDetails.offerCountRemaining === 0;

  return (
    <div className="min-h-full">

      <main className="pb-8">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
          <h1 className="sr-only">{t('insurer:insuranceOfferDetail')}</h1>
          <div className="flex justify-end mb-8">
            {insurerOffer ? <div className="w-full border-b border-gray-200">
              <p className="text-2xl font-bold text-neatcar">{t('insurer:offerSent')}</p>
              <div className="flex flex-row items-center justify-between mt-4">
                <span className="text-lg font-bold text-gray-900 w-1/3">{t('insurer:amount')}</span>
                <span className="text-lg font-bold text-gray-900 w-1/3">{t('insurer:date')}</span>
                <span className="text-lg font-bold text-gray-900 flex-1">{t('insurer:status')}</span>
              </div>
              <div className="flex flex-row items-center justify-between pb-2">
                <span className="text-base font-medium text-neatcar w-1/3">{parseFloat(insurerOffer.priceAnually / 100).toFixed(2)}$</span>
                <span className="text-base font-medium text-neatcar w-1/3">{dayjs(insurerOffer.createdAt).format('YYYY-MM-DD HH:mm')}</span>
                <span className={`text-base font-medium flex-1 ${insurerOffer.isAccepted ? "text-green-600" : "text-yellow-600"}`}>{insurerOffer.isAccepted ? t('insurer:accepted') : t('insurer:pending')}</span>
                <Button className={'bg-red-600'} onClick={deleteOffer}>
                  {t('insurer:deleteOffer')}
                </Button>
              </div>
            </div> :
            <div>
            
              <Button className={`${limitReached ? 'opacity-50 cursor-not-allowed' : ''}`} tooltip={limitReached ? t('insurer:noMoreOffer') : undefined} onClick={() => { if (!limitReached && didFetchDetail) setIsModalOpen(true) }}>
                {t('insurer:sendOffer')}
              </Button>
              {/* <Button onClick={() => { setIsYousetModalOpen(true) }}>
                {t('insurer:sendOffer')}
              </Button> */}
              </div>
              }
              
          </div>
          
          <div className="grid grid-cols-1 items-start gap-4 lg:grid-cols-4 lg:gap-8">
            <div className="grid grid-cols-1 gap-4 lg:col-span-2">
              <section aria-labelledby="section-2-title">
                <h2 className="sr-only" id="section-2-title">{t('insurer:driverInformation')}</h2>
                <div className="overflow-hidden rounded-lg bg-white shadow">
                  <div className="p-6">
                    <div className="border-b border-gray-200 bg-white pb-3">
                      <h3 className="text-base font-semibold text-gray-900">{t('insurer:driverInformation')}</h3>
                    </div>
                    <div className="grid grid-cols-2 gap-4 p-8">
                      <div className="inline-block">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:fullName')}</h3>
                        <p>{userAssurance?.informations.firstName} {userAssurance?.informations.lastName}</p>
                      </div>
                      <div className="inline-block">
                        <h3 className="text-base font-semibold text-gray-900">{t('neatcover:contactEmail')}</h3>
                        <p>{`neatcover.${userAssurance?.userId}@neatcar.com`}</p>
                      </div>
                      <div className="inline-block">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:birthday')}</h3>
                        <p>{dayjs(userAssurance?.informations.birthday).format('YYYY-MM-DD')}</p>
                      </div>
                      <div className="inline-block">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:gender')}</h3>
                        <p>{t(`insurer:${userAssurance?.informations.genderCertificate || userAssurance?.informations.gender}`)}</p>
                      </div>
                      <div className="inline-block">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:workProfession')}</h3>
                        <p>{userAssurance?.informations.workProfession}</p>
                      </div>
                      <div className="inline-block">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:creditScore')}</h3>
                        <p>{t(`insurer:credit${capitalize(userAssurance?.informations.creditScore)}`)}</p>
                      </div>
                      <div className="inline-block col-span-2">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:verificationProfile')}</h3>
                        <p>{t(`insurer:${userAssurance?.informations.verificationProfile}`)}</p>
                      </div>
                      <div className="col-span-2 border-t border-gray-200 pt-2">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:discount')}</h3>
                        <div className="pt-2">
                          <ul className="grid grid-cols-2 gap-2 w-full">
                            {discountOptions.map((option, index) => (
                              <li key={index} className="flex items-center">
                                <span className="mr-2">•</span>
                                <span className={discountsKey.find(x => x === option) ? "" : "opacity-50 line-through"}>{t(`insurer:${option}`)}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section aria-labelledby="section-2-title">
                <h2 className="sr-only" id="section-2-title">{t('insurer:driverInformation')}</h2>
                <div className="overflow-hidden rounded-lg bg-white shadow">
                  <div className="p-6">
                    <div className="border-b border-gray-200 bg-white pb-3">
                      <h3 className="text-base font-semibold text-gray-900">{t('insurer:driverLicense')}</h3>
                    </div>
                    <div className="grid grid-cols-2 gap-4 p-8">
                      <div className="inline-block">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:licenseNumber')}</h3>
                        <p>{userAssurance?.informations.licenseNumber}</p>
                      </div>
                      <div className="inline-block">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:yearGotLicense')}</h3>
                        <p>{userAssurance?.informations.yearGotLicense}</p>
                      </div>
                      <div className="inline-block">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:carLicense')}</h3>
                        <p>{userAssurance?.informations.carLicense}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section aria-labelledby="section-2-title">
                <h2 className="sr-only" id="section-2-title">{t('insurer:driverAddress')}</h2>
                <div className="overflow-hidden rounded-lg bg-white shadow">
                  <div className="p-6">
                    <div className="border-b border-gray-200 bg-white pb-3">
                      <h3 className="text-base font-semibold text-gray-900">{t('insurer:driverAddress')}</h3>
                    </div>
                    <div className="grid grid-cols-2 gap-4 p-8">
                      <div className="inline-block col-span-2">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:address')}</h3>
                        <p>{userAssurance?.informations.address}</p>
                      </div>
                      <div className="inline-block">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:addressSince')}</h3>
                        <p>{dayjs(userAssurance?.informations.addressDate).format('YYYY-MM-DD')}</p>
                      </div>
                      <div className="inline-block">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:isOpenToHomeInsurance')}</h3>
                        <p>{t(`insurer:${userAssurance?.informations.insuranceHome}`)}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section aria-labelledby="section-2-title">
                <h2 className="sr-only" id="section-2-title">{t('insurer:driverInsurer')}</h2>
                <div className="overflow-hidden rounded-lg bg-white shadow">
                  <div className="p-6">
                    <div className="border-b border-gray-200 bg-white pb-3">
                      <h3 className="text-base font-semibold text-gray-900">{t('insurer:driverInsurer')}</h3>
                    </div>
                    <div className="grid grid-cols-2 gap-4 p-8">
                      <div className="inline-block">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:isInsuredSince')}</h3>
                        <p>{t(`insurer:${userAssurance?.informations.howLongActualAssurance}`)}</p>
                      </div>
                      <div className="inline-block">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:insuranceRenewalMonth')}</h3>
                        <p>{t(`month:${userAssurance?.informations.currentInsurerMonthExpiry?.toLowerCase()}`)}</p>
                      </div>
                      <div className="inline-block">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:currentInsurer')}</h3>
                        <p>{t(`insurer:${userAssurance?.informations.currentInsurer}Insurer`)}</p>
                      </div>
                      <div className="inline-block">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:currentInsurerYears')}</h3>
                        <p>{t(`insurer:${userAssurance?.informations.currentInsurerYears}`)}</p>
                      </div>
                      <div className="inline-block">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:insurerCancelationNumberInLast5Years')}</h3>
                        <p>{t(`insurer:${userAssurance?.informations.insurerCancelationNumberInLast5Years}`)}</p>
                      </div>
                      <div className="inline-block">  
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:satisfiedWithCurrentInsurer')}</h3>
                        <p>{t(`insurer:${userAssurance?.informations.satisfiedWithCurrentInsurer}`)}</p>
                      </div>
                      
                    </div>
                  </div>
                </div>
              </section>
              <section aria-labelledby="section-2-title">
                <h2 className="sr-only" id="section-2-title">{t('insurer:tickets')}</h2>
                <div className="overflow-hidden rounded-lg bg-white shadow">
                  <div className="p-6">
                    <div className="border-b border-gray-200 bg-white pb-3">
                      <h3 className="text-base font-semibold text-gray-900">{t('insurer:tickets')}</h3>
                    </div>
                    {userAssurance?.informations.last5YearsTickets0 === 'yesButNoInformation' && <p className="text-md font-bold text-red-400 mt-4">{t('insurer:userSaidTheyHaveTicketsButDidNotProvideAnyInformation')}</p>}
                    {userAssurance?.informations.last5YearsTickets0 !== 'yesButNoInformation' && !userHaveTicket ? <p className="mt-4">{t('insurer:noTickets')}</p> : <div />}
                    {userHaveTicket && 
                    <ul className="w-full space-y-8 mt-8">
                      <li className="flex flex-row border-b border-gray-200 pb-2">
                        <div className="w-1/2">
                          <p className="text-lg font-bold text-neatcar">
                            {t('insurer:explanation')}
                          </p>
                        </div>
                        <div className="w-1/2">
                          <p className="text-lg font-bold text-neatcar">
                            {t('insurer:date')}
                          </p>
                        </div>
                      </li>
                      {tickets.map((ticket, index) => (
                        <li key={`ticket-${index}`} className="flex flex-row border-b border-gray-200 pb-2">
                          <div className="w-1/2">
                            <p>
                              {ticket.explain}
                            </p>
                          </div>
                          <div className="w-1/2">
                            <p>
                              {dayjs(ticket.year).format('YYYY-MM-DD')}
                            </p>
                          </div>
                        </li>
                      ))}
                  </ul>}
                  </div>
                </div>
              </section>
              <section aria-labelledby="section-2-title">
                <h2 className="sr-only" id="section-2-title">{t('insurer:homeDetails')}</h2>
                <div className="overflow-hidden rounded-lg bg-white shadow">
                  <div className="p-6">
                    <div className="border-b border-gray-200 bg-white pb-3">
                      <h3 className="text-base font-semibold text-gray-900">{t('insurer:accident')}</h3>
                    </div>
                    {userAssurance?.informations.last6YearsAccidents0 === 'yesButNoInformation' && <p className="text-md font-bold text-red-400 mt-4">{t('insurer:userSaidTheyHaveAccidentsButDidNotProvideAnyInformation')}</p>}
                    {userAssurance?.informations.last6YearsAccidents0 !== 'yesButNoInformation' && !userHaveAccident ? <p className="mt-4">{t('insurer:noTickets')}</p> : <div />}
                    {userHaveAccident && 
                    <ul className="w-full space-y-8 mt-8">
                      <li className="flex flex-row border-b border-gray-200 pb-2">
                        <div className="w-1/3">
                          <p className="text-lg font-bold text-neatcar">
                            {t('insurer:explanation')}
                          </p>
                        </div>
                        <div className="w-1/3">
                          <p className="text-lg font-bold text-neatcar">
                            {t('insurer:amount')}
                          </p>
                        </div>
                        <div className="w-1/3">
                          <p className="text-lg font-bold text-neatcar">
                            {t('insurer:date')}
                          </p>
                        </div>
                      </li>
                      {accidents.map((accident, index) => (
                        <li key={`accident-${index}`} className="flex flex-row border-b border-gray-200 pb-2">
                          <div className="w-1/3">
                            <p>
                              {accident.explain}
                            </p>
                          </div>
                          <div className="w-1/3">
                            <p>
                              {accident.claimAmount}$
                            </p>
                          </div>
                          <div className="w-1/3">
                            <p>
                              {dayjs(accident.claimDate).format('YYYY-MM-DD')}
                            </p>
                          </div>
                        </li>
                      ))}
                    </ul>}
                  </div>
                </div>
              </section>
              <section aria-labelledby="section-2-title">
                <h2 className="sr-only" id="section-2-title">{t('insurer:policyInformation')}</h2>
                <div className="overflow-hidden rounded-lg bg-white shadow">
                  <div className="p-6">
                    <div className="border-b border-gray-200 bg-white pb-3">
                      <h3 className="text-base font-semibold text-gray-900">{t('insurer:policyInformation')}</h3>
                    </div>
                    <div className="grid grid-cols-2 gap-4 p-8">
                      <div className="inline-block">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:civilResponsability')}</h3>
                        <p>{userAssurance?.informations.civilResponsability}</p>
                      </div>
                      <div className="inline-block">  
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:collision')}</h3>
                        <p>{userAssurance?.informations.colision ? t('insurer:yes') : t('insurer:no')}</p>
                      </div>
                      <div className="inline-block">  
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:franchise')}</h3>
                        <p>{userAssurance?.informations.colision ? `${userAssurance?.informations.franchise}$` : 'N/A'}</p>
                      </div>
                     
                      <div className="inline-block">  
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:riskToOther')}</h3>
                        <p>{userAssurance?.informations.colision ? `${userAssurance?.informations.riskOther}$` : 'N/A'}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <div className="grid grid-cols-1 gap-4 lg:col-span-2">
              <section aria-labelledby="section-2-title">
                <h2 className="sr-only" id="section-2-title">{t('insurer:carInformation')}</h2>
                <div className="overflow-hidden rounded-lg bg-white shadow">
                  <div className="p-6">
                    <div className="border-b border-gray-200 bg-white pb-3">
                      <h3 className="text-base font-semibold text-gray-900">{t('insurer:carInformation')}</h3>
                    </div>
                    <div className="border-b border-gray-200 bg-white pb-3 flex flex-row mt-6">
                      <div className="w-1/2 border-r px-8">
                        <h3 className="text-base font-semibold text-gray-900">{userAssurance?.userCar.car.make} {userAssurance?.userCar.car.model}</h3>
                        <p>{userAssurance?.userCar.car.year} - {t(`insurer:${userAssurance?.userCar.color}`)}</p>
                      </div>
                      <div className="w-1/2 bg-white pb-3 px-8">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:trim')}</h3>
                        <p>{userAssurance?.userCar.car.Trim}</p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-4 p-8">
                      <div className="overflow-hidden col-span-2">
                        <div className="p-6 items-center self-center justify-center flex flex-row">
                          <img src={userAssurance?.userCar.pictureUrl} alt="carImage" className="w-48 h-48 object-contain" />
                        </div>
                      </div>
                      <div className="inline-block">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:purchaseAmount')}</h3>
                        <p>{userAssurance?.informations.financeAmount}$</p>
                      </div>
                      <div className="inline-block">  
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:boughtType')}</h3>
                        <p>{t(`insurer:${userAssurance?.informations.boughtType}`)}</p>
                      </div>
                      <div className="inline-block">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:boughtState')}</h3>
                        <p>{t(`insurer:${userAssurance?.informations.boughtState}Car`)}</p>
                      </div>
                      <div className="inline-block">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:boughtDate')}</h3>
                        <p>{dayjs(userAssurance?.informations.boughtDate).format('YYYY-MM-DD')}</p>
                      </div>
                      <div className="inline-block  w-full">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:antitheft')}</h3>
                        <p>{t(`insurer:${userAssurance?.informations.antitheft}`)}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section aria-labelledby="section-2-title">
                <h2 className="sr-only" id="section-2-title">{t('insurer:carFinanceInformation')}</h2>
                <div className="overflow-hidden rounded-lg bg-white shadow">
                  <div className="p-6">
                    <div className="border-b border-gray-200 bg-white pb-3">
                      <h3 className="text-base font-semibold text-gray-900">{t('insurer:carFinanceInformation')}</h3>
                    </div>
                    <div className="grid grid-cols-2 gap-4 p-8">
                      <div className="inline-block">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:carCreditor')}</h3>
                        <p>{userAssurance?.informations.creditorName ?? (userAssurance?.informations.carCreditor ?? 'N/A')}</p>
                      </div>
                      <div className="inline-block">  
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:creditorAddress')}</h3>
                        <p>{userAssurance?.informations.creditorAddress ? userAssurance?.informations.creditorAddress : 'N/A'}</p>
                      </div>
                      <div className="inline-block">  
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:interest')}</h3>
                        <p>{userAssurance?.informations.interest ? `${userAssurance?.informations.interest}%` : 'N/A'}</p>
                      </div>
                      <div className="inline-block">  
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:financeDuration')}</h3>
                        <p>{userAssurance?.informations.financeDuration ? `${userAssurance?.informations.financeDuration}` : 'N/A'}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section aria-labelledby="section-2-title">
                <h2 className="sr-only" id="section-2-title">{t('insurer:carUsage')}</h2>
                <div className="overflow-hidden rounded-lg bg-white shadow">
                  <div className="p-6">
                    <div className="border-b border-gray-200 bg-white pb-3">
                      <h3 className="text-base font-semibold text-gray-900">{t('insurer:carUsage')}</h3>
                    </div>
                    <div className="grid grid-cols-2 gap-4 p-8">
                      <div className="inline-block">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:kilometerDaily')}</h3>
                        <p>{userAssurance?.informations.kilometerDaily}KM</p>
                      </div>
                      <div className="inline-block">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:kilometerAnnually')}</h3>
                        <p>{userAssurance?.informations.kilometerAnnually}KM</p>
                      </div>
                      <div className="inline-block">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:demoKilometers')}</h3>
                        <p>{userAssurance?.informations.demoKilometers}KM</p>
                      </div>
                      <div className="inline-block">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:usage')}</h3>
                        <p>{t(`insurer:${userAssurance?.informations.usage}`)}</p>
                      </div>
                      <div className="inline-block">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:weekOutOfState')}</h3>
                        <p>{t(`insurer:${userAssurance?.informations.weekOutOfState}`)}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section aria-labelledby="section-2-title">
                <h2 className="sr-only" id="section-2-title">{t('insurer:carDetails')}</h2>
                <div className="overflow-hidden rounded-lg bg-white shadow">
                  <div className="p-6">
                    <div className="border-b border-gray-200 bg-white pb-3">
                      <h3 className="text-base font-semibold text-gray-900">{t('insurer:carDetails')}</h3>
                    </div>
                    <ul className="w-full space-y-8">
                    {userInsuranceDetailCarLabel.filter(label => label && label.length > 0).length === 0 ?
                        <li key={`carDetail-NoCarDetails`} className="flex flex-row pb-2 mt-4">
                          <div className="w-full">
                            <p>
                              {t('insurer:noCarDetails')}
                            </p>
                          </div>
                        </li> : <div />}
                      {userInsuranceDetailCarLabel.filter(label => label && label.length > 0).map((carDetail, index) => (
                        <li key={`ticket-${index}`} className="flex flex-row border-b border-gray-200 pb-2">
                          <div className="w-full">
                            <p>
                              {carDetail}
                            </p>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </section>
              <section aria-labelledby="section-2-title">
                <h2 className="sr-only" id="section-2-title">{t('insurer:homeDetails')}</h2>
                <div className="overflow-hidden rounded-lg bg-white shadow">
                  <div className="p-6">
                    <div className="border-b border-gray-200 bg-white pb-3">
                      <h3 className="text-base font-semibold text-gray-900">{t('insurer:homeDetails')}</h3>
                    </div>
                    <ul className="w-full space-y-8">
                      {userInsuranceDetailHomeLabel.filter(label => label && label.length > 0).length === 0 ?
                        <li key={`homeDetail-NoHomeDetails`} className="flex flex-row pb-2 mt-4">
                          <div className="w-full">
                            <p>
                              {t('insurer:noHomeDetails')}
                            </p>
                          </div>
                        </li> : <div />}
                      {userInsuranceDetailHomeLabel.filter(label => label && label.length > 0).map((homeDetail, index) => (
                        <li key={`ticket-${index}`} className="flex flex-row border-b border-gray-200 pb-2">
                          <div className="w-full">
                            <p>
                              {homeDetail}
                            </p>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </section>
              <section aria-labelledby="section-2-title">
                <h2 className="sr-only" id="section-2-title">{t('insurer:additionalCoverage')}</h2>
                <div className="overflow-hidden rounded-lg bg-white shadow">
                  <div className="p-6">
                    <div className="border-b border-gray-200 bg-white pb-3">
                      <h3 className="text-base font-semibold text-gray-900">{t('insurer:additionalCoverage')}</h3>
                    </div>
                    <div className="grid grid-cols-2 gap-4 p-8">
                      <div className="inline-block">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:locationFee')}</h3>
                        <p>{userAssurance?.informations.locationFee ? t('insurer:yes') : t('insurer:no')}</p>
                      </div>
                      <div className="inline-block">  
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:damageToOther')}</h3>
                        <p>{userAssurance?.informations.damageOther}$</p>
                      </div>
                      <div className="inline-block">  
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:roadAssistance')}</h3>
                        <p>{userAssurance?.informations.roadAssistance ? t('insurer:yes') : t('insurer:no')}</p>
                      </div>
                     
                      <div className="inline-block">  
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:accidentBenefits')}</h3>
                        <p>{userAssurance?.informations.accidentBenefits ? t('insurer:yes') : t('insurer:no')}</p>
                      </div>
                      <div className="inline-block">  
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:newReplacement')}</h3>
                        <p>{userAssurance?.informations.newReplacement ? t('insurer:yes') : t('insurer:no')}</p>
                      </div>
                      <div className="inline-block">
                        <h3 className="text-base font-semibold text-gray-900">{t('insurer:hitAndRunExemption')}</h3>
                        <p>{userAssurance?.informations.franchiseExemptionHitAndRun ? t('insurer:yes') : t('insurer:no')}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
             
            </div>
          </div>
          
          
        </div>
        <NewOfferModal userAssuranceId={userAssurance?.id} isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
      </main>
    </div>
  )
};

export default InsuranceOfferDetail;
